// src/components/Teams/WebsiteAssignment.js
import React, { useState, useEffect } from 'react';
import { ListGroup, Form, Button, Spinner } from 'react-bootstrap';
import useWebsiteStore from '../../store/websiteStore';

const WebsiteAssignment = ({ teamId, teamWebsites, assignWebsiteToTeam, onRemove, loading }) => {
    const { websites, fetchWebsites } = useWebsiteStore();
    const [availableWebsites, setAvailableWebsites] = useState([]);
    const [selectedWebsite, setSelectedWebsite] = useState('');

    useEffect(() => {
        fetchWebsites();
    }, [fetchWebsites]);

    useEffect(() => {
        if (websites.length > 0 && teamWebsites) {
            const teamWebsiteIds = teamWebsites.map(w => w.id);
            setAvailableWebsites(websites.filter(w => !teamWebsiteIds.includes(w.id)));
        }
    }, [websites, teamWebsites]);

    const handleAssign = () => {
        if (selectedWebsite) {
            assignWebsiteToTeam(teamId, selectedWebsite);
            setSelectedWebsite('');
        }
    };

    return (
        <div>
            <div className="mb-4">
                <div className="d-flex mb-2">
                    <Form.Select
                        value={selectedWebsite}
                        onChange={(e) => setSelectedWebsite(e.target.value)}
                        className="me-2"
                    >
                        <option value="">Vyberte web pro přiřazení...</option>
                        {availableWebsites.map(website => (
                            <option key={website.id} value={website.id}>
                                {website.name || website.url}
                            </option>
                        ))}
                    </Form.Select>
                    <Button
                        variant="primary"
                        onClick={handleAssign}
                        disabled={!selectedWebsite || loading}
                    >
                        {loading ? (
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        ) : (
                            <i className="fas fa-plus"></i>
                        )}
                    </Button>
                </div>
            </div>

            <ListGroup>
                {teamWebsites && teamWebsites.length > 0 ? (
                    teamWebsites.map(website => (
                        <ListGroup.Item
                            key={website.id}
                            className="d-flex justify-content-between align-items-center"
                        >
                            <div>
                                <div>{website.name || website.url}</div>
                                <small className="text-muted">{website.url}</small>
                            </div>
                            <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => onRemove(teamId, website.id)}
                                disabled={loading}
                            >
                                <i className="fas fa-times"></i>
                            </Button>
                        </ListGroup.Item>
                    ))
                ) : (
                    <ListGroup.Item className="text-center text-muted py-4">
                        Tento tým nemá přiřazené žádné weby
                    </ListGroup.Item>
                )}
            </ListGroup>
        </div>
    );
};

export default WebsiteAssignment;